import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "app-e-signature",
    templateUrl: "./e-signature.component.html",
    styleUrls: ["./e-signature.component.scss"],
    standalone: false
})
export class ESignatureComponent extends BaseControlComponent implements OnInit {
    static componentName = "ESignatureComponent";

    public defaultLegalHeader: string = "That I hereby agree to conform with all provisions of Chapter 1509, ORC, to all orders and rules issued by the Chief of the Division of Oil and Gas Resources Management.";
    public defaultLegalFooter: string = "Chapter 1306: Uniform Electronic Transaction Act; <a target='_blank' href='/law-library/0nhgZH0nnlO92w07' rel='noopener noreferrer'>1306.01(H) ORC</a>";
    public consent: string;

    agreeChecked(): boolean {
        return this.consent === "agree";
    }

    declineChecked(): boolean {
        return this.consent === "decline";
    }

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        super.ngOnInit();

        if (!this.componentData.label || this.componentData.label.length === 0)
            this.componentData.label = this.defaultLegalHeader;

        if (!this.componentData.config.display)
            this.componentData.config.display = { legalFooter: this.defaultLegalFooter };

        this.consent = this.getContext("agreement");
    }

    storeConsent(value: string): void {
        this.consent = value;
        this.storeContext(this.consent, "agreement");
        this.formGroup.get(this.componentData.key).updateValueAndValidity();
    }

    hasValidation(): boolean {
        if (!this.componentData.validationRules || this.componentData.validationRules.length === 0) return false;
        const req = this.componentData.validationRules.find(v => v.key === "signature");
        return (req !== undefined && req !== null);
    }
}
